/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ completed: NonNullable<unknown>, total: NonNullable<unknown> }} Uploading_FramesInputs */



/**
* | output |
* | --- |
* | "Uploading frames ({completed}/{total})..." |
*
* @param {Uploading_FramesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const uploading_frames = /** @type {((inputs: Uploading_FramesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uploading_FramesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Chargement des images (${i?.completed}/${i?.total})...`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Frames werden hochgeladen (${i?.completed}/${i?.total})...`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Caricamento dei frame (${i?.completed}/${i?.total})...`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Загрузка кадров (${i?.completed}/${i?.total})...`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Subiendo fotogramas (${i?.completed}/${i?.total})...`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`正在上传帧（${i?.completed}/${i?.total}）...`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`フレームをアップロード中（${i?.completed}/${i?.total}）...`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`फ़्रेम अपलोड किए जा रहे हैं (${i?.completed}/${i?.total})...`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Carregando frames (${i?.completed}/${i?.total})...`)
	return /** @type {LocalizedString} */ (`Uploading frames (${i?.completed}/${i?.total})...`)
});